import { ItemDetalhado } from "../persistences/item-detalhado";

export class IDialogItemDetalhado {
    trilhaItens?: Map<number, ItemDetalhado>;
    itemDetalhado?: ItemDetalhado;
    id?: number;
}